import WorkoutScalingOption from './WorkoutScalingOption';

class Benchmark {
  constructor({
    _id = null,
    title = '',
    subtitles = [],
    exercises = [],
    description = '',
    scaling = [],
    resultType = null,
  }) {
    this.id = _id;
    this.title = title;
    this.subtitles = subtitles;
    this.exercises = exercises;
    this.description = description;
    this.scaling = scaling.map(
      (scalingOption) => new WorkoutScalingOption(scalingOption)
    );
    this.resultType = resultType;
  }
}

export default Benchmark;
